module.exports = __webpack_public_path__ + "static/media/starPoints.f6bb954c.svg";